import leadsAPI from 'dashboard/api/nexceo/leads';
import { useEmitter } from 'dashboard/composables/emitter';

// M26.15.7 — VerifiedLeadsPage.vue and AllLeadsPage.vue each keep their own
// server-paginated/filtered `leads` ref rather than the shared nexceoLeads
// Vuex store used by KanbanPage.vue/CalendarPage.vue — correctly so: their
// view is a filtered/paginated subset, and forcing them onto the store's
// single shared `records` list would corrupt whichever page last populated
// it (e.g. Kanban's project-scoped fetch overwriting Verified Leads'
// verified-only, paginated one). Both pages had independently implemented
// the identical "listen for the two live NEXCEO websocket events, refetch
// the one affected lead, splice it in place" logic — this composable is the
// one shared implementation, reusing the existing useEmitter composable for
// mount/unmount wiring instead of each page managing it by hand.
export function useNexceoLeadLiveSync(leadsRef, selectedLeadRef) {
  async function refreshLeadInPlace(leadId) {
    if (!leadId) return;
    const idx = leadsRef.value.findIndex(l => l.id === leadId);
    if (idx === -1) return;
    try {
      const { data } = await leadsAPI.show(leadId);
      leadsRef.value.splice(idx, 1, data);
      if (selectedLeadRef?.value?.id === leadId) {
        selectedLeadRef.value = data;
      }
    } catch {
      /* non-fatal — next natural reload will pick it up */
    }
  }

  useEmitter('nexceo_lead.updated', data => refreshLeadInPlace(data.lead_id));
  useEmitter('nexceo_site_visit.updated', data =>
    refreshLeadInPlace(data.lead_id)
  );

  return { refreshLeadInPlace };
}
